import Provizyon from './Provizyon'
export default Provizyon
